import { TaxRate, Taxation } from '@mews-commander/types';
import { LocalizedCurrencyValue, LocalizedPercent } from '@mews/framework';
import { Grid, GridItem } from '@optimus-web/core';

interface TaxationsSubTableProps {
    taxations: Taxation[];
}

const getValueString = (strategy: TaxRate['strategy']) => {
    if (strategy.discriminator === 'Flat') {
        return (
            <LocalizedCurrencyValue
                value={{
                    value: strategy.value.value,
                    currency: strategy.value.currencyCode,
                }}
            />
        );
    }
    return <LocalizedPercent percent={strategy.value.value} options={{ precision: 1 }} />;
};

export const TaxationsSubTable: React.FC<TaxationsSubTableProps> = ({ taxations }) => (
    <Grid divider="horizontal" columnGap="0" style={{ width: '100%' }}>
        {taxations.map((t: Taxation) => (
            <Grid key={t.code} templateColumns="repeat(3, minmax(0, 1fr))">
                <GridItem>{`${t.localName} (${t.name})`}</GridItem>
                <GridItem column="span 2">
                    <Grid divider="horizontal" columnGap="0" style={{ width: '100%' }}>
                        {t.taxRates.map((tr) => (
                            <Grid key={tr.code} templateColumns="repeat(2, minmax(0, 1fr))">
                                <GridItem>{getValueString(tr.strategy)}</GridItem>
                                <GridItem>{tr.code}</GridItem>
                            </Grid>
                        ))}
                    </Grid>
                </GridItem>
            </Grid>
        ))}
    </Grid>
);
